import { Component, inject } from '@angular/core';
import { ConnectivityService } from '@app/core/services/connectivity.service';

@Component({
  selector: 'app-offline-banner',
  standalone: true,
  template: `
    @if (!connectivity.isOnline()) {
      <div
        role="alert"
        class="flex items-center gap-3 px-4 py-2.5 bg-amber-500 text-amber-950 text-sm font-medium shadow-md"
      >
        <i class="pi pi-wifi text-base"></i>
        <span>
          <strong>No internet connection.</strong>
          Greezmate can't reach the server — please check your wifi or mobile data. Your work will
          resume automatically once you're back online.
        </span>
      </div>
    }
  `,
})
export class OfflineBannerComponent {
  protected readonly connectivity = inject(ConnectivityService);
}
